function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }
  
  function eraseCookie(name) {   
    document.cookie = name+`=;domain=${window.location.hostname};path=/;max-age=-99999;expires=Thu, 01 Jan 1970 00:00:00 GMT"`;  
  }

  function getAndEraseCookie(name) {
      var cookie = getCookie(name)
      eraseCookie(name)
      return cookie
  }

  export {
    getAndEraseCookie,
    getCookie,
    eraseCookie
  }